export default {
  title: "Mis votaciones",
  loading: "Cargando tus votos...",
  emptyState: "Aún no has realizado ninguna votación",
}
